import globalEN from '@translations/en/global.json';
import globalCZ from '@translations/cz/global.json';



export const resources = {
	en: {
		global: globalEN
	},
	cz: {
		global: globalCZ
	}
} as const;